import React, { useContext, useState } from 'react';
import { SignUpModal } from '../../../components/shared/SignUpModal';
import { GlobalSiteDataContext } from '../../../context';
import { MilanCredit } from '../../../components/specials/home/MilanCredit';

export default function MilanCreditBuilder() {
    const [showSignUpModal, setShowSignUpModal] = useState(false);
    const siteData = useContext(GlobalSiteDataContext);

    return (
        <div>
            {showSignUpModal && <SignUpModal {...{ siteData, showSignUpModal, setShowSignUpModal }} />}
            <MilanCredit setShowSignUpModal={setShowSignUpModal} globalData={siteData?.globalData} />
        </div>
    );
}
